module.exports = __webpack_public_path__ + "media/assets/images/coming_soon-d313bd8c1ab745b2db6056c1231660a5.png";